export const FIREBASE_ERROR_MESSAGES = {
    INVALID_EMAIL: 'Invalid email address format.',
    INVALID_CREDENTIALS: 'Invalid credentials. Please check your email and password.',
    INVALID_PASSWORD: 'Invalid password. Please check your password.',
    INVALID_LOGIN_CREDENTIALS: 'Invalid login credentials. Please check your email and password.',
    INVALID_EMAIL_OR_PASSWORD: 'Invalid email or password. Please check your email and password.',
    INVALID_EMAIL_OR_PASSWORD_CREDENTIALS: 'Invalid email or password or credentials. Please check your email and password.',
    USER_NOT_FOUND: 'No user found with this email.',
    WRONG_PASSWORD: 'Incorrect password.',
    USER_ALREADY_EXISTS: 'This email is already registered.',
    WEAK_PASSWORD: 'Password is too weak. Use at least 6 characters.',
    POPUP_CLOSED_BY_USER: 'Login popup was closed before completing sign in.',
    ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIAL: 'Account exists with a different login method.',
    NETWORK_REQUEST_FAILED: 'Network error. Please check your internet connection.',
    USER_DISABLED: 'This account has been disabled.',
    POPUP_BLOCKED: 'Popup blocked by browser. Allow popups and try again.',
    UNKNOWN_ERROR: 'An unknown error occurred. Please try again.',
  };
  